import { render } from "./AccountsProjectsList.vue?vue&type=template&id=d248391a"
import script from "./AccountsProjectsList.vue?vue&type=script&lang=js"
export * from "./AccountsProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__